import React, { useState, useEffect } from "react";
// import clsx from "clsx";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import CardMedia from "@mui/material/CardMedia";

import { BiImageAdd } from "react-icons/bi";
import { mediaImageUploader as classes } from "./styles";

export interface Props {
  onImageSelect: Function;
  imageUrl?: string;
}

const MediaImageUploader = ({ onImageSelect, imageUrl }: Props) => {
  const [mediaFileUrl, setMediaFileUrl] = useState<string>();
  const [showOverlay, setShowOverlay] = useState(false);
  let inputFile: any;

  useEffect(() => {
    setMediaFileUrl(imageUrl);
  }, [imageUrl]);

  // handle the image select event
  const handleImageSelect = (event: any) => {
    if (event.target.files[0]) {
      const mediaFile = event.target.files[0];
      const mediaFileUrl = URL.createObjectURL(mediaFile);
      setMediaFileUrl(mediaFileUrl);
      onImageSelect(mediaFile);
      setShowOverlay(false);
    }
  };

  const handleUploadClick = (e: any) => {
    e.preventDefault();
    inputFile.click();
    return false;
  };

  return (
    <Box
      sx={classes.mediaWrapper}
      onMouseLeave={() => {
        setShowOverlay(false);
      }}
      onMouseEnter={() => {
        setShowOverlay(true);
      }}
    >
      <input
        ref={(input) => input && (inputFile = input)}
        id="btn-image-upload"
        name="btn-image-upload"
        style={{ display: "none" }}
        type="file"
        accept="image/*"
        onChange={handleImageSelect}
      />
      <label htmlFor="btn-image-upload">
        {mediaFileUrl && (
          <CardMedia
            component={"img"}
            sx={{
              position: "absolute",
              left: 0,
              top: 0,
              height: "100%", //auto
              background: "#fff",
              borderRadius: "50%",
              border: "1px solid #E7E7E7",
              filter: "drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.05))",
              cursor: "pointer",
            }}
            // sx={clsx(classes.media)}
            src={mediaFileUrl}
          />
        )}
      </label>

      {(showOverlay || !mediaFileUrl) && (
        <ButtonBase onClick={handleUploadClick} sx={classes.overlay}>
          <BiImageAdd fontSize="2vw" />
        </ButtonBase>
      )}
    </Box>
  );
};

export default MediaImageUploader;
